import Axios from 'axios' 
import {
  SYSUSERROLE_UNSET_ALL_STATE,
  SYSUSERROLE_SET_MSG,
  SYSUSERROLE_UNSET_MSG,
  SYSUSERROLE_SET_SCHEMA,
  SYSUSERROLE_UNSET_SCHEMA,
  SYSUSERROLE_SET_ACTION_PROCESS,
  SYSUSERROLE_UNSET_ACTION_PROCESS,
  SYSUSERROLE_SET_LIST_DATA, 
  SYSUSERROLE_UNSET_LIST_DATA,
  SYSUSERROLE_SET_ACTION_STATUS,
  SYSUSERROLE_UNSET_ACTION_STATUS

} from '../mutation-types'

const state = {     
  dataList: [],   
  message: '',
  actionStatus:false, 
  actionProcess:false, 
  Schema:{ 
    id:0,    
    role_name: '',
    role_description: '',
    active: 1,
    login_id: ''
  }
}

const getters = {
  get_SYSUSERROLE_DataList (state) {
    return state.dataList ;
  }, 
  get_SYSUSERROLE_ActionMessage(state){
    return state.message ;
  },
  get_SYSUSERROLE_Schema(state){
    return state.Schema
  },
  get_SYSUSERROLE_ActionProcess(state){
    return state.actionProcess ;
  },
  get_SYSUSERROLE_ActionStatus(state){
    return state.actionStatus ;
  },

}

// mutations

const	mutations = {	
  [SYSUSERROLE_UNSET_ALL_STATE] (state){
    state.actionProcess = false,
    state.dataList = [],      
    state.Schema = {
      id:0,    
      role_name: '',
      role_description: '',
      active: 1,
      login_id: ''
    }  
  },
  [SYSUSERROLE_SET_ACTION_STATUS](state){
    state.actionStatus = true
  },
  [SYSUSERROLE_UNSET_ACTION_STATUS](state){
    state.actionStatus = false
  },
  [SYSUSERROLE_SET_MSG](state,msg){
    state.message = msg
  },
  [SYSUSERROLE_UNSET_MSG](state){
    state.message = ""
  },
  [SYSUSERROLE_UNSET_ACTION_PROCESS]( state ){ 
    state.actionProcess = false
  },
  [SYSUSERROLE_SET_ACTION_PROCESS]( state ){
    state.actionProcess = true 
  },
  [SYSUSERROLE_SET_LIST_DATA](state,itemList){
    state.dataList = itemList 
  },
  [SYSUSERROLE_UNSET_LIST_DATA](state){
    state.dataList = [] 
  },
  [SYSUSERROLE_SET_SCHEMA](state,schemaData){
    state.Schema = schemaData 
  },
  [SYSUSERROLE_UNSET_SCHEMA](state){
    state.Schema = {} 
    state.Schema.active =1
  },
}

// Actions

const actions = {
	
}

export default {
 state,
 getters,
 actions,
 mutations
}



// WEBPACK FOOTER //
// ./src/vuex/module/dia_sysUserrole_module.js